<template>
	<div class="list-container column">
		<div class="title-container" :class="{ mobile: isMobile }">
			<h1 class="title">Dokument</h1>
			<div class="field">
				<div class="template-wrapper mb-1">
					<div class="template-wrapper__header">
						Mallar:
					</div>
					<button
						class="button is-info"
						@click.prevent="
							downloadTemplate(policyLink, 'Mall_Brandskyddspolicy')
						"
					>
						Brandskyddspolicy
						<i class="fas fa-download"></i>
					</button>
					<button
						class="button is-info"
						@click.prevent="
							downloadTemplate(rulesLink, 'Mall_Reger_och_rutiner')
						"
					>
						Regler och rutiner
						<i class="fas fa-download"></i>
					</button>
					<button
						class="button is-info"
						@click.prevent="
							downloadTemplate(businessLink, 'Mall_Verksamhetsbeskrivning')
						"
					>
						Verksamhetsbeskrivning
						<i class="fas fa-download"></i>
					</button>
				</div>
				<div class="file has-name is-fullwidth is-dark mb-1" v-if="$isAllowedTo('documents_upload')">
					<label class="file-label">
						<input
							ref="fileupload"
							class="file-input"
							type="file"
							name="resume"
							accept=".doc, .docx, .pdf, .xlsx, .xls"
							@change="uploadFile"
						/>
						<span class="file-cta">
							<span class="file-icon">
								<i class="fas fa-upload"></i>
							</span>
							<span class="file-label">
								Välj en fil...
							</span>
						</span>
						<span class="file-name">
							{{ fileName }}
						</span>
					</label>
					<button
						class="button is-info"
						:disabled="file === null"
						@click.prevent="saveFile"
					>
						<span class="icon"><i class="fas fa-plus"/></span>
					</button>
				</div>
			</div>
		</div>
		<div class="panel-list-header">
			<div class="panel-header-item">Namn</div>
			<div v-if="!isMobile" class="panel-header-item">Skapad</div>
			<div class="panel-filler" v-if="$isAllowedTo('files_edit')" />
			<div class="panel-filler" v-if="$isAllowedTo('files_edit')" />
		</div>
		<div
			class="panel-list"
			v-for="file in files"
			:key="file.id"
			@click.stop="onSelect(file)"
		>
			<div class="panel-list-item">{{ file.name }}</div>
			<div v-if="!isMobile" class="panel-list-item">
				{{ file.created.substring(0, 10) }}
			</div>
			<div class="list-button" v-if="$isAllowedTo('files_edit')" @click.stop="onSelect(file)">
				<i class="fas fa-download"></i>
			</div>
			<div
				v-if="file && $isAllowedTo('files_edit')"
				class="list-button"
				@click.stop="onDelete(file)"
			>
				<i class="fas fa-trash-alt"></i>
			</div>
		</div>
		<div class="panel-list no-hover" v-if="files.length == 0">
			<p class="panel-list-item">Inga resultat</p>
		</div>
		<Pagination
			v-if="files.length > 0"
			:pagination="pagination"
			@paginate="paginate"
			@updatePageSize="updatePageSize"
		/>
	</div>
</template>

<script>
import Pagination from '@/components/Pagination';
import { mapGetters, mapActions } from 'vuex';

export default {
	components: {
		Pagination
	},

	props: {
		files: Array
	},

	data() {
		return {
			file: null,
			policyLink: '/documents/Brandskyddspolicy.docx',
			rulesLink: '/documents/Regler_och_rutiner.docx',
			businessLink: '/documents/Verksamhetsbeskrivning.docx'
		};
	},

	computed: {
		...mapGetters('fileStore', ['pagination']),
		...mapGetters('appStore', ['isMobile']),

		fileName() {
			return this.file ? this.file.name : 'Ingen fil vald';
		}
	},

	methods: {
		...mapActions('fileStore', ['setCurrentPage', 'setPageSize']),
		onDelete(file) {
			this.$emit('delete', file);
		},
		onEdit(file) {
			this.$emit('edit', file);
		},
		paginate(page) {
			this.setCurrentPage(page);
			this.$emit('search');
		},
		updatePageSize(size) {
			this.setPageSize(size);
			this.setCurrentPage(1);
			this.$emit('search');
		},
		uploadFile(event) {
			this.file = event.target.files[0];
		},
		saveFile() {
			this.$emit('save', this.file);
			this.file = null;
			this.reset();
		},
		downloadTemplate(url, fileName) {
			const link = document.createElement('a');
			link.href = url;
			link.setAttribute('download', fileName);
			document.body.appendChild(link);
			link.click();
			this.$nextTick(() => {
				document.body.removeChild(link);
			});
		},
		onSelect(file) {
			this.$emit('download', file);
		},
		reset() {
			const input = this.$refs.fileupload;
			input.type = 'text';
			input.type = 'file';
		}
	}
};
</script>

<style lang="scss" scoped>
.title-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;

  > .title {
	white-space: nowrap;
	font-size: 24px;
	line-height: 2.5rem;
	margin-bottom: 0 !important;
	min-width: 200px;
  }

  &.mobile {
    flex-wrap: wrap;
    .file {
      width: calc(100vw - 1.2rem);
    }
  }
  .file {
    min-width: 280px;
    max-width: 400px;
  }
  .field {
    display: flex;
	flex-wrap: wrap;
    .button {
      border-radius: 2px;
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }
  }
  .file-name {
    border-radius: 0;
  }
}
.template-wrapper {
  display: flex;
  flex-wrap: wrap;
  margin-right: 100px;

  &__header {
	margin-left: 0;
	margin-right: 1rem;
	line-height: 2.5rem;
  }

  .button {
    margin-right: 5px;
	margin-bottom: .5rem;

    .fas {
      margin-left: 5px;
    }
  }
}
</style>
